import { Text } from '@rtkwlf/c3-core-react';

import styles from './security-focus-timeline-item-info.module.css';

type SecurityFocusTimelineItemInfoProps = {
  className?: string;
  heading: string;
  value: string | string[];
};

export const SecurityFocusTimelineItemInfo = ({
  className,
  heading,
  value,
}: SecurityFocusTimelineItemInfoProps) => {
  const Info = () => {
    if (Array.isArray(value)) {
      if (value.length === 0) {
        return (
          <Text size="2" contrast="medium">
            -
          </Text>
        );
      }

      if (value.length === 1) {
        return (
          <Text size="2" contrast="medium">
            {value[0]}
          </Text>
        );
      }

      return (
        <ul className={styles['sft-item-info-list']}>
          {value.map((v) => {
            return (
              <li key={v}>
                <Text contrast="medium" size="2">
                  {v}
                </Text>
              </li>
            );
          })}
        </ul>
      );
    }

    return (
      <Text size="2" contrast="medium">
        {value}
      </Text>
    );
  };
  return (
    <div className={`${styles['sft-item-info']} ${className}`}>
      <Text size="2" weight="bold">
        {heading}
      </Text>
      <Info />
    </div>
  );
};
